export const EasyWebApp_QQ = new URL('./EasyWebApp-QQ.png', import.meta.url) + '';
export const ECMAScript = new URL('./ECMAScript.png', import.meta.url) + '';
export const Google_Translate = new URL('./Google-Translate.png', import.meta.url) + '';
export const Web_Components = new URL('./Web-Components.svg', import.meta.url) + '';
export const WebCell_0 = new URL('./WebCell-0.png', import.meta.url) + '';
export const WebCell_1 = new URL('./WebCell-1.png', import.meta.url) + '';
